import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { deleteContact, getContacts } from '../../../../../api/endpoints/cmsSite';
import type { SiteContact } from '../../../../../api/types/cmsSite';
import { ConfirmDialog } from '../../../../../components/ConfirmDialog';
import {
  ListPageScaffold,
  RowActions,
  useDeleteResource,
  type DataTableColumn,
} from '../../../../../components/common';
import { ContactFormDialog } from '../ContactFormDialog';

export default function ContactListPage({ siteId }: { siteId: number }) {
  const [createOpen, setCreateOpen] = useState(false);
  const [editing, setEditing] = useState<SiteContact | null>(null);

  const query = useQuery({ queryKey: ['cms', 'contacts', siteId], queryFn: () => getContacts(siteId) });
  const rows: SiteContact[] = useMemo(() => query.data?.contacts ?? [], [query.data]);

  const del = useDeleteResource<number>({
    mutationFn: (id) => deleteContact(id),
    invalidateKeys: [['cms', 'contacts']],
    successMessage: 'İletişim kaydı silindi.',
  });

  const columns: DataTableColumn<SiteContact>[] = [
    { id: 'title', header: 'Başlık', cell: (r) => r.title ?? '—' },
    { id: 'phone', header: 'Telefon', cell: (r) => r.phone ?? '—' },
    { id: 'email', header: 'E-posta', cell: (r) => r.email ?? '—' },
    { id: 'address', header: 'Adres', cell: (r) => r.address ?? '—' },
  ];

  return (
    <ListPageScaffold
      title="İletişim"
      headerVariant="section"
      createLabel="Yeni İletişim Kaydı"
      onCreate={() => setCreateOpen(true)}
      query={query}
      rows={rows}
      columns={columns}
      getRowKey={(r) => r.id}
      emptyTitle="Kayıtlı iletişim kaydı bulunamadı."
      rowActions={(r) => <RowActions onEdit={() => setEditing(r)} onDelete={() => del.request(r.id)} />}
    >
      <ContactFormDialog open={createOpen} contact={null} siteId={siteId} onClose={() => setCreateOpen(false)} />
      <ContactFormDialog open={!!editing} contact={editing} siteId={siteId} onClose={() => setEditing(null)} />
      <ConfirmDialog
        {...del.confirmDialogProps}
        title="İletişim kaydını sil"
        description="Bu iletişim kaydını silmek istediğinize emin misiniz?"
      />
    </ListPageScaffold>
  );
}
